/**
 * @generated SignedSource<<da28d2474b8d108ed922e3abb61e974d>>
 * @relayHash e9b1989f0b3a96928d65615eb3e74d3d
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID e9b1989f0b3a96928d65615eb3e74d3d

import { ConcreteRequest } from 'relay-runtime';
export type emergencyCitySelectorCitySearchQuery$variables = {
  countryIsoCode: string;
  keyword?: string | null;
};
export type emergencyCitySelectorCitySearchQuery$data = {
  readonly displayableCitySearch: ReadonlyArray<{
    readonly label: string;
    readonly postalCode: string;
    readonly value: string;
  }>;
};
export type emergencyCitySelectorCitySearchQuery = {
  response: emergencyCitySelectorCitySearchQuery$data;
  variables: emergencyCitySelectorCitySearchQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "countryIsoCode"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "keyword"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "countryIsoCode",
        "variableName": "countryIsoCode"
      },
      {
        "kind": "Variable",
        "name": "keyword",
        "variableName": "keyword"
      }
    ],
    "concreteType": "DisplayableCity",
    "kind": "LinkedField",
    "name": "displayableCitySearch",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "label",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "value",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "postalCode",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "emergencyCitySelectorCitySearchQuery",
    "selections": (v1/*:: as any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "emergencyCitySelectorCitySearchQuery",
    "selections": (v1/*:: as any*/)
  },
  "params": {
    "id": "e9b1989f0b3a96928d65615eb3e74d3d",
    "metadata": {},
    "name": "emergencyCitySelectorCitySearchQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "6d8e4a4d75a55adb77202e692b9a77bd";

export default node;
